BaseManager = require 'BaseManager'
gameModel = require 'gameModel'
log = require 'loglevel'

###############################################

class LayoutManager extends BaseManager

  name: 'LayoutManager'
  offset: 116
  padding: 56

  #----------------------------

  placeButton: (button)->
    return unless button?
    x = Math.round((gameModel.gameWidth-button.width)/2)
    y = Math.round((gameModel.rendererHeight - @offset) - (@padding * button.order))
    button.x = x
    button.y = y

  #----------------------------

  repositionY: (button)->
    return unless button?
    y = Math.round((gameModel.rendererHeight - @offset) - (@padding * button.order))
    button.y = y

#----------------------------

module.exports = LayoutManager.getInstance()


// WEBPACK FOOTER //
// ./coffee/manager/layout-manager.coffee